import { SongInsightsData } from '../Dashboard';

// Helper for station/genre/region name list
export const getStationNameList = (names: string[]) => {
  const list = names.map((name) => name).slice(0, 3);
  if (list.length === 0) return { items: '', last: '' };
  if (list.length === 1) return { items: '', last: list[0] };
  return {
    items: list.slice(0, -1).join(', '),
    last: list[list.length - 1],
  };
};

export const hasMorningInsight = (songInsightsData?: SongInsightsData) =>
  !!songInsightsData?.peak_airplay?.groups?.MORNING?.stations?.length;

export const hasAfternoonInsight = (songInsightsData?: SongInsightsData) =>
  !!songInsightsData?.peak_airplay?.groups?.AFTERNOON?.stations?.length;

export const hasEveningInsight = (songInsightsData?: SongInsightsData) =>
  !!songInsightsData?.peak_airplay?.groups?.EVENING?.stations?.length;

export const hasNightInsight = (songInsightsData?: SongInsightsData) =>
  !!songInsightsData?.peak_airplay?.groups?.NIGHT?.stations?.length;

export const hasMomentumInsight = (songInsightsData?: SongInsightsData) =>
  songInsightsData?.momentum && !songInsightsData?.momentum?.message;

export const hasRotationInsight = (songInsightsData?: SongInsightsData) =>
  !!songInsightsData?.stations_on_rotation?.length;

export const hasRegionsInsight = (songInsightsData?: SongInsightsData) =>
  !!songInsightsData?.top_regions?.length;

export const hasGenresInsight = (songInsightsData?: SongInsightsData) =>
  !!songInsightsData?.top_genres?.length;

// verify if there are no insights to render
export const hasInsigthsToRender = (songInsightsData?: SongInsightsData) => {
  return (
    hasMorningInsight(songInsightsData) ||
    hasAfternoonInsight(songInsightsData) ||
    hasEveningInsight(songInsightsData) ||
    hasNightInsight(songInsightsData) ||
    hasMomentumInsight(songInsightsData) ||
    hasRotationInsight(songInsightsData) ||
    hasRegionsInsight(songInsightsData) ||
    hasGenresInsight(songInsightsData)
  );
};
